export class Client {
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.number = data.Phonenumber.replace("+98", "0");
        this.registrationDate = data.RegistrationDate;
        this.city = data.city;
        this.datebirth = data.Datebirth;
        this.OwnerNumber = data.OwnerNumber;
        this.GuestNumber = data.GuestNumber;
        this.userDeviceNumbers = `مالک ${this.OwnerNumber}, مهمان ${this.GuestNumber}`;
    }

    getId() {
        return this.id;
    }

    getOwnerAndGuestNumber() {
        return `مالک ${this.OwnerNumber}, مهمان ${this.GuestNumber}`;
    }
}

/*
class Client{
    id;
    name;
    number;
    registrationDate;
    city;
    datebirth;
    OwnerNumber;
    GuestNumber;
    constructor(name,number,registrationDate,city,datebirth,OwnerNumber,GuestNumber,id){
        this.name=name;
        this.number=number;
        this.registrationDate=registrationDate;
        this.city=city;
        this.datebirth=datebirth;
        this.OwnerNumber = OwnerNumber;
        this.GuestNumber=GuestNumber;
        this.id=id

    }
    getId(){
        return this.id;
    };

    getOwnerAndGuestNumber(){
        return `مالک ${this.OwnerNumber},مهمان${this.GuestNumber}`
    }
}
export {Client}*/
